import React from 'react';
import { defaultTemplate } from 'core/hoc';

function NotFoundTemplate({ rootStore, t }) {
	return (
		<div className="container--404">
			<img
				className="w--200--px display--b align--h--center spc--bottom--xlrg"
				src={require('themes/img/logo.svg')}
				alt="Logo"
			/>
			<div className="w--400--px align--h--center type--center">
				<img className="display--b spc--bottom--med spc--top--med" src={require('themes/img/es-default.svg')} />
				<p className="spc--bottom--med w--250--px align--h--center">{t('NOTFOUND')}</p>
				<button
					className="btn btn--med btn--primary"
					onClick={() => rootStore.routerStore.goTo('master.app.main.home')}
				>
					{t('HOME')}
				</button>
			</div>
		</div>
	);
}

export default defaultTemplate(NotFoundTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/root/pages/NotFoundTemplate.jsx